const biologicalSex = ["Masculino", "Femenino"];
export default biologicalSex;
